"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = init;
// biome-ignore lint: -
require("core-js/stable");
require("regenerator-runtime/runtime");
const oidc_client_ts_1 = require("oidc-client-ts");
const browser_unhandled_rejection_1 = require("browser-unhandled-rejection");
const React = __importStar(require("react"));
const ReactRedux = __importStar(require("react-redux"));
const react_dom_1 = require("react-dom");
const styled_components_1 = require("styled-components");
const GlobalActions = __importStar(require("@genesys/client-core/lib/global-actions"));
const ClientConfig = __importStar(require("./client-config"));
const store_1 = require("./store");
const root_1 = require("./root");
// A ponyfill/polyfill for browser Promise unhandledrejection events.
(0, browser_unhandled_rejection_1.auto)();
// Polyfill setImmediate, setInterval
// biome-ignore lint: -
require("timers-browserify");
const GlobalStyle = (0, styled_components_1.createGlobalStyle) `
  html {
    /* http://meyerweb.com/eric/tools/css/reset/
    v2.0 | 20110126
    License: none (public domain)
    */

    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      font: inherit;
      vertical-align: baseline;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
      display: block;
    }
    body {
      line-height: 1;
    }
    ol, ul {
      list-style: none;
    }
    blockquote, q {
      quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
      content: '';
      content: none;
    }
    table {
      border-collapse: collapse;
      border-spacing: 0;
    }


    /* Start global styles */
    font-family: sans-serif;
    font-size: 14px;
    a,
    a:link,
    a:visited,
    a:hover,
    a:active {
      color: rgb(115, 169, 216);
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
      cursor: pointer;
    }

    body {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      display: flex;
      flex-direction: column;
    }

    #root {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
`;
const manager = initializeOidc();
async function init() {
    if (isLoginCallbackRequest(window.location)) {
        const user = await manager.signinCallback();
        if (!user) {
            await manager.signinRedirect({ state: window.location.href });
            return;
        }
        window.location.href = String(user.state) || "/";
    }
    else {
        const user = await manager.getUser();
        if (!user) {
            await manager.signinRedirect({ state: window.location.href });
            return;
        }
        const store = (0, store_1.createStore)(ClientConfig.config);
        const showError = (error) => {
            console.error(error);
            store.dispatch(GlobalActions.error({
                referenceNo: "",
                invalidState: true,
                message: error.message,
                exception: error.stack
            }));
        };
        window.addEventListener("unhandledrejection", (event) => {
            showError(event.reason);
        });
        // const spec: GlobalActions.OpenTabSpecification = {
        //   id: Guid.createGuid(),
        //   title: "Welcome",
        //   subject: GlobalActions.createStartTabSubject()
        // };
        // const johanTest: GlobalActions.OpenTabSpecification = {
        //   id: Guid.createGuid(),
        //   title: "Systemeditor",
        //   subject: GlobalActions.createSystemEditorSubject(
        //     Guid.guidFromString("ee2be5d1-f2c2-4410-aa66-f7cb6991e6e5")
        //   ),
        //   renderer: "SystemEditor",
        //   rendererProps: ""
        // };
        // store.dispatch(GlobalActions.requestOpenTab(spec));
        // store.dispatch(GlobalActions.requestOpenTab(johanTest));
        window.onerror = function (msg, _1, _2, _3, error) {
            console.error(error);
            if (!error) {
                try {
                    const e = new Error(msg);
                    console.log(e);
                }
                catch (e) {
                    showError(e);
                    return;
                }
            }
            showError(error);
            return true;
        };
        store.dispatch(GlobalActions.userLoggedIn(user.access_token));
        manager.events.addUserLoaded(user => {
            store.dispatch(GlobalActions.userLoggedIn(user.access_token));
        });
        const mountNode = document.getElementById("root");
        (0, react_dom_1.render)(React.createElement(React.Fragment, null,
            React.createElement(ReactRedux.Provider, { store: store },
                React.createElement(root_1.Root, null)),
            React.createElement(GlobalStyle, null)), mountNode);
    }
}
function initializeOidc() {
    // biome-ignore lint: -
    if (ClientConfig.config.environment === "localhost" && false) {
        oidc_client_ts_1.Log.setLogger(console);
        oidc_client_ts_1.Log.setLevel(4);
    }
    const manager = new oidc_client_ts_1.UserManager({
        authority: ClientConfig.config.oidcAuthority,
        client_id: ClientConfig.config.oidcClientId,
        redirect_uri: ClientConfig.config.oidcRedirectUri,
        response_type: ClientConfig.config.oidcResponseType,
        scope: ClientConfig.config.oidcScope,
        monitorSession: false,
        loadUserInfo: false,
        automaticSilentRenew: ClientConfig.config.oidcResponseType === "code"
    });
    manager.events.addAccessTokenExpired(async () => {
        await manager.signinRedirect({ state: window.location.href });
    });
    return manager;
}
function isLoginCallbackRequest(location) {
    return (location.hash.indexOf("id_token") > -1 ||
        location.pathname.startsWith("/signinoidc"));
}
//# sourceMappingURL=main.js.map